module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.9785/images/homepage/white-curved-header.svg"